import { useSelector } from 'react-redux'
import { formatDate } from '@calendly/booking-kit/services/time_format'

import { useI18n } from 'locales'
import { inviteeEventsSelector, firstEventWithConflictIdSelector } from 'selectors/mutual_availability'
import { currentUserLocaleSelector } from 'selectors/user'
import { daySelector } from 'selectors/calendar'

import InviteeEvent from './invitee_event'
import { Date, EmptyMessage } from './styles'

const InviteeEventList = ({ containerScreenPosition, variant = 'default' }) => {
  const { i18n } = useI18n()
  const events = useSelector(inviteeEventsSelector)
  const locale = useSelector(currentUserLocaleSelector)
  const firstEventWithConflictId = useSelector(firstEventWithConflictIdSelector)
  const selectedDay = useSelector(daySelector)?.date

  if (!events) return null

  return (
    <>
      {variant !== 'redesign' && (
        <Date>
          {formatDate(selectedDay, i18n.t('time.formats.date_extra'))}
        </Date>
      )}
      {
        events.map(({
          event_name: eventName,
          start_time: startTime,
          end_time: endTime,
          all_day: allDay,
          id
        }) => (
          <InviteeEvent
            key={id}
            id={id}
            startTime={startTime}
            endTime={endTime}
            eventName={eventName}
            autoScroll={id === firstEventWithConflictId}
            containerScreenPosition={containerScreenPosition}
            allDay={allDay}
            variant={variant}
          />
        ))
      }

      {
        events.length === 0
          && <EmptyMessage>{i18n.t('publisher.mutual_availability.no_events', { locale })}</EmptyMessage>
      }
    </>
  )
}

export default InviteeEventList
